import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Spinner,
} from "reactstrap";
import { useState, useEffect } from "react";
import { useMutation } from "react-query";
import { postShifts, updateShifts } from "../../../MyApi/shifts";
import { toast } from "react-toastify";

const daysMap = [
  "الأحد",
  "الإثنين",
  "الثلاثاء",
  "الأربعاء",
  "الخميس",
  "الجمعة",
  "السبت",
];

const ShiftsModal = ({
  isOpen,
  toggle,
  id,
  refetch,
  mode = "add",
  shiftData = null,
}) => {
  const initialForm = {
    name: "",
    is_active: 1,
    is_flexible: 0,
    store_id: id,
    days: [
      {
        day_of_week: 0,
        is_off_day: 0,
        start_time: "",
        end_time: "",
        break_duration: 60,
        is_flexible: 0,
        working_hours: 8,
      },
      {
        day_of_week: 1,
        is_off_day: 0,
        start_time: "",
        end_time: "",
        break_duration: 60,
        is_flexible: 0,
        working_hours: 8,
      },
      {
        day_of_week: 2,
        is_off_day: 0,
        start_time: "",
        end_time: "",
        break_duration: 60,
        is_flexible: 0,
        working_hours: 8,
      },
      {
        day_of_week: 3,
        is_off_day: 0,
        start_time: "",
        end_time: "",
        break_duration: 60,
        is_flexible: 0,
        working_hours: 8,
      },
      {
        day_of_week: 4,
        is_off_day: 0,
        start_time: "",
        end_time: "",
        break_duration: 60,
        is_flexible: 0,
        working_hours: 8,
      },
      { day_of_week: 5, is_off_day: 1, is_flexible: 0, working_hours: "" },
      { day_of_week: 6, is_off_day: 1, is_flexible: 0, working_hours: "" },
    ],
  };
  const [formData, setFormData] = useState(initialForm);

  useEffect(() => {
    if (mode === "add") {
      setFormData(initialForm);
    } else if ((mode === "edit" || mode === "view") && shiftData) {
      setFormData({
        name: shiftData.name || "",
        is_active: shiftData.is_active ? 1 : 0,
        is_flexible: shiftData.is_flexible ? 1 : 0,
        store_id: id,
        days: shiftData.days.map((day) => ({
          ...day,
          is_off_day: Number(day.is_off_day),
          is_flexible: Number(day.is_flexible),
        })),
      });
    }
  }, [mode, shiftData, id]);

  const postMutation = useMutation({
    mutationKey: ["postShifts"],
    mutationFn: (postData) => postShifts(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      toggle();
      refetch();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });

  const updateMutation = useMutation({
    mutationKey: ["updateShifts"],
    mutationFn: (postData) => updateShifts(postData, shiftData?.id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      toggle();
      refetch();
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });
  const validateTimeRange = (startTime, endTime) => {
    if (!startTime || !endTime) return true; // Allow empty values
    const convertTimeToMinutes = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    };
    const start = convertTimeToMinutes(startTime);
    const end = convertTimeToMinutes(endTime);
    console.log("start", start, "end", end);
    return true;
  };

  const handleDayChange = (index, field, value) => {
    console.log("index", index, field, value);

    if (
      field === "end_time" &&
      !validateTimeRange(formData.days[index].start_time, value)
    ) {
      toast.error("وقت النهاية يجب أن يكون بعد وقت البداية");
      return;
    }
    setFormData((prev) => {
      const days = [...prev.days];
      days[index] = { ...days[index], [field]: value };
      return { ...prev, days };
    });
  };

  const handleSubmit = () => {
    const preparedData = {
      ...formData,
      days: formData.days.map((day) => {
        // يوم إجازة
        if (day.is_off_day === 1) {
          return {
            day_of_week: day.day_of_week,
            is_off_day: 1,
            is_flexible: day.is_flexible,
          };
        }

        // يوم مرن
        if (day.is_flexible === 1) {
          return {
            day_of_week: day.day_of_week,
            is_off_day: 0,
            is_flexible: 1,
            working_hours: day.working_hours,
            break_duration: day.break_duration,
          };
        }

        // يوم عادي
        return {
          day_of_week: day.day_of_week,
          is_off_day: 0,
          is_flexible: 0,
          start_time: day.start_time,
          end_time: day.end_time,
          break_duration: day.break_duration,
          working_hours: day.working_hours,
        };
      }),
    };

    if (mode === "edit") {
      preparedData._method = "PUT";
      updateMutation.mutate(preparedData);
    } else {
      postMutation.mutate(preparedData);
    }
  };
  console.log("formData.days", formData.days);
  const getModalTitle = () => {
    switch (mode) {
      case "edit":
        return "تعديل موعد عمل";
      case "view":
        return "عرض موعد عمل";
      default:
        return "إضافة موعد عمل";
    }
  };

  const getSubmitButtonText = () => {
    if (mode === "edit") return "تأكيد التعديل";
    return "تأكيد الإضافة";
  };

  const isReadOnly = mode === "view";

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{getModalTitle()}</ModalHeader>

      <ModalBody>
        <label htmlFor="">اسم موعد العمل</label>
        <Input
          placeholder="أدخل اسم موعد العمل"
          className="mb-2"
          value={formData.name}
          disabled={isReadOnly}
          onChange={(e) => setFormData({ ...formData, name: e.target.value })}
        />

        {/* دوام مرن */}
        <div className="d-flex align-items-center gap-2 mt-2 mb-3">
          <label htmlFor="">دوام مرن</label>
          <label class="switch">
            <input
              type="checkbox"
              disabled={isReadOnly}
              onChange={(e) => {
                const isFlexible = e.target.checked ? 1 : 0;
                setFormData((prev) => {
                  // When global flexible is turned ON, set all days to flexible
                  // When turned OFF, keep existing day states
                  const updatedDays = prev.days.map((day) => ({
                    ...day,
                    is_flexible: isFlexible === 1 ? 1 : day.is_flexible,
                  }));
                  return {
                    ...prev,
                    is_flexible: isFlexible,
                    days: updatedDays,
                  };
                });
              }}
              checked={formData.is_flexible === 1}
            />
            <span className="slider round"></span>
          </label>
          {formData.is_flexible === 1 && <span>جدول مرن</span>}
        </div>
        <div className="d-flex align-items-center gap-2 mt-2 mb-3">
          <label htmlFor=""> نشط</label>
          <label class="switch">
            <input
              type="checkbox"
              disabled={isReadOnly}
              onChange={(e) => {
                const isActive = e.target.checked ? 1 : 0;
                setFormData((prev) => {
                  return { ...prev, is_active: isActive };
                });
              }}
              checked={formData.is_active === 1}
            />
            <span className="slider round"></span>
          </label>
        </div>

        {/* الأيام */}
        {formData.days.map((day, index) => (
          <div key={index} className="mb-3 border p-2 rounded add">
            <strong>{daysMap[day.day_of_week]}</strong>

            {/* يوم إجازة */}
            <div className="d-flex align-items-center gap-2 mt-2">
              <label htmlFor="">يوم عطلة</label>
              <label class="switch">
                <input
                  type="checkbox"
                  disabled={isReadOnly}
                  onChange={(e) =>
                    handleDayChange(
                      index,
                      "is_off_day",
                      e.target.checked ? 1 : 0,
                    )
                  }
                  checked={day.is_off_day === 1}
                />
                <span className="slider round"></span>
              </label>

              {day.is_off_day === 1 ? <span>يوم إجازة</span> : null}
            </div>

            <div>
              <label htmlFor="">يوم مرن</label>
              <label class="switch">
                <input
                  type="checkbox"
                  disabled={isReadOnly}
                  onChange={(e) =>
                    handleDayChange(
                      index,
                      "is_flexible",
                      e.target.checked ? 1 : 0,
                    )
                  }
                  checked={day.is_flexible === 1}
                />
                <span className="slider round"></span>
              </label>
            </div>

            {/* وقت العمل */}
            {!day.is_off_day && (
              <div className="d-flex gap-2 mt-2">
                {day.is_flexible === 0 && (
                  <>
                    <div>
                      <label htmlFor=""> وقت البداية </label>
                      <Input
                        type="time"
                        value={day.start_time}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          handleDayChange(index, "start_time", e.target.value)
                        }
                      />
                    </div>
                    <div>
                      <label htmlFor="">وقت النهاية</label>
                      <Input
                        type="time"
                        value={day.end_time}
                        disabled={isReadOnly}
                        onChange={(e) =>
                          handleDayChange(index, "end_time", e.target.value)
                        }
                      />
                    </div>
                  </>
                )}
                <div>
                  <label htmlFor="">وقت الراحة</label>
                  <Input
                    type="number"
                    placeholder="مدة الراحة (دقيقة)"
                    value={day.break_duration}
                    disabled={isReadOnly}
                    onChange={(e) =>
                      handleDayChange(index, "break_duration", +e.target.value)
                    }
                  />
                </div>
                <div>
                  <label htmlFor="">ساعات العمل</label>
                  <Input
                    type="number"
                    placeholder="  ساعات العمل"
                    value={day.working_hours}
                    disabled={isReadOnly}
                    onChange={(e) =>
                      handleDayChange(index, "working_hours", +e.target.value)
                    }
                  />
                </div>
              </div>
            )}
          </div>
        ))}
      </ModalBody>

      <ModalFooter className="d-flex justify-content-start">
        {mode !== "view" && (
          <Button
            color="primary"
            onClick={handleSubmit}
            disabled={
              mode === "edit"
                ? updateMutation.isLoading
                : postMutation.isLoading
            }
          >
            {(
              mode === "edit"
                ? updateMutation.isLoading
                : postMutation.isLoading
            ) ? (
              <Spinner />
            ) : (
              getSubmitButtonText()
            )}
          </Button>
        )}
        <Button className="btn btn-white" onClick={toggle}>
          {mode === "view" ? "إغلاق" : "إلغاء"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ShiftsModal;
